import React from 'react';

const AlertasCriticosTable = ({ alertasData }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold mb-4">Alerta de Pontos Críticos</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="bg-red-100">
              <th className="px-4 py-2 text-left">Nome</th>
              <th className="px-4 py-2 text-left">Departamento</th>
              <th className="px-4 py-2 text-left">Observação</th>
            </tr>
          </thead>
          <tbody>
            {alertasData.map((alerta, index) => (
              <tr key={index} className="border-b hover:bg-red-50">
                <td className="px-4 py-2">{alerta.nome_pessoa}</td>
                <td className="px-4 py-2">{alerta.departamento}</td>
                <td className="px-4 py-2">{alerta.observacao}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AlertasCriticosTable;